"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedWidgetType = exports.isSpotWidget = exports.isSellwildWidget = exports.isNewslettersWidget = exports.isKeystoneWidget = exports.isFallbackVideoWidget = exports.isBytesWidget = exports.isAdWidget = exports.typeGuards = void 0;
const plugins_1 = require("../plugins");
// Type guard factory that creates type guards for each widget type with their specific config
const createWidgetTypeGuard = (type) => {
    return (w) => {
        return w.widgetType === type;
    };
};
// Create type guards for each widget type with their specific config types
exports.typeGuards = plugins_1.SUPPORTED_PLUGINS.reduce((guards, type) => ({
    ...guards,
    [`is${type}Widget`]: createWidgetTypeGuard(type),
}), {});
// Export individual type guards for convenience
exports.isAdWidget = exports.typeGuards.isAdWidget, exports.isBytesWidget = exports.typeGuards.isBytesWidget, exports.isFallbackVideoWidget = exports.typeGuards.isFallbackVideoWidget, exports.isKeystoneWidget = exports.typeGuards.isKeystoneWidget, exports.isNewslettersWidget = exports.typeGuards.isNewslettersWidget, exports.isSellwildWidget = exports.typeGuards.isSellwildWidget, exports.isSpotWidget = exports.typeGuards.isSpotWidget;
// Main type guard to check if a widget is of a supported type
const isSupportedWidgetType = (w) => {
    return Object.values(exports.typeGuards).some((guard) => guard(w));
};
exports.isSupportedWidgetType = isSupportedWidgetType;
//# sourceMappingURL=typeGuards.js.map